import Api from '../../services';

const getBookingPayment = (id) => {
  return (dispatch) => {
    return Api.payments.getBookingPayment(id).then((response) => {
      dispatch({
        type: 'GET_BOOKING_PAYMENT',
        data: response,
      });
      return response;
    });
  };
};

export default getBookingPayment;
